import React, { useEffect, useState } from "react";
import Header from "../../../component/organisms/header";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Sidebar from "../../../component/organisms/sidebar";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import moment from "moment";
import { useNavigate, useParams } from "react-router-dom";
import GoBack from "../../../component/molecules/goBack";
import DetailTop from "../../../component/atoms/layout/detail/detailTop";
import DetailPage from "../../../component/atoms/layout/detail/detailPage";
import DetailPageTitle from "../../../component/atoms/text/detail/detailPageTitle";
import DetailPageForm from "./../../../component/atoms/layout/detail/detailPageForm";
import DetailFormTitle from "./../../../component/atoms/text/detail/detailFormTitle";
import DetailFormText from "./../../../component/atoms/text/detail/detailFormText";
import RedBtn from "../../../component/atoms/button/redBtn";
import MemberApi from "../../../api/member.api";
import { errorHandler } from "../../../util/errorHandler";
import { toast } from "react-toastify";
import { toastMsg } from "../../../util/toastMsg";
import Modal from "../../../component/templates/Modal";
import { cMembershipList } from "../../../constants/userInfoConstants";
import { formatNumberWithCommas } from "../../../util/formatNumber";
import { route } from "../../../router/route";

const UserWithdrawDetail = () => {
  let { id } = useParams();
  const navigate = useNavigate();
  const [isWriteAuthority, setIsWriteAuthority] = useState(false);

  // ---------- 쓰기 권한체크 ---------- //
  useEffect(() => {
    const writeMenu = sessionStorage.getItem("writeMenu");

    if (writeMenu?.includes(route.user_withdraw)) {
      setIsWriteAuthority(true);
    } else {
      setIsWriteAuthority(false);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const [userInfo, setUserInfo] = useState();

  useEffect(() => {
    getUserInfoFunc();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const getUserInfoFunc = async () => {
    try {
      const response = (await MemberApi.retiredMemberDetail(id)).data.data
        .content;

      setUserInfo(response);
    } catch (error) {
      errorHandler(error);
    }
  };

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const deleteFunc = async () => {
    try {
      let data = {
        ids: [id],
        allFlag: false,
      };

      await MemberApi.retiredMemberDel(data);

      setDeleteModalOpen(false);
      toast(toastMsg.delete);

      navigate(-1);
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 본문 영역 */}
        <DetailPageLayout>
          <DetailTop>
            <GoBack />

            {isWriteAuthority && (
              <RedBtn
                onClick={() => {
                  setDeleteModalOpen(true);
                }}
                style={{
                  backgroundColor: "#272829",
                }}
              >
                내역 삭제
              </RedBtn>
            )}
          </DetailTop>
          <DetailPage
            style={{
              minHeight: "556px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginBottom: 30,
              }}
            >
              <DetailPageTitle
                style={{
                  marginBottom: 12,
                }}
              >
                회원 상세 내역
              </DetailPageTitle>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 140,
                    }}
                  >
                    이름
                  </DetailFormTitle>
                  <DetailFormText>{userInfo?.name}</DetailFormText>
                </DetailPageForm>
                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 140,
                    }}
                  >
                    아이디(이메일)
                  </DetailFormTitle>
                  <DetailFormText>{userInfo?.email}</DetailFormText>
                </DetailPageForm>
                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 140,
                    }}
                  >
                    닉네임
                  </DetailFormTitle>
                  <DetailFormText>{userInfo?.nickname}</DetailFormText>
                </DetailPageForm>
                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 140,
                    }}
                  >
                    회원등급/레벨
                  </DetailFormTitle>
                  <DetailFormText>
                    {cMembershipList[userInfo?.membership]}/Lv.
                    {userInfo?.writingLevel}
                  </DetailFormText>
                </DetailPageForm>
                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 140,
                    }}
                  >
                    누적구매
                  </DetailFormTitle>
                  <DetailFormText>
                    {userInfo?.purchaseCount}회/
                    {formatNumberWithCommas(userInfo?.purchaseAmount)}원
                  </DetailFormText>
                </DetailPageForm>
                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 140,
                    }}
                  >
                    보유포인트
                  </DetailFormTitle>
                  <DetailFormText>
                    {formatNumberWithCommas(userInfo?.totalPoint)}P
                  </DetailFormText>
                </DetailPageForm>
                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 140,
                    }}
                  >
                    가입일
                  </DetailFormTitle>
                  <DetailFormText>
                    {moment(userInfo?.joinDate).format("YYYY-MM-DD HH:mm")}
                  </DetailFormText>
                </DetailPageForm>
                <DetailPageForm
                  style={{
                    gap: 32,
                    height: 46,
                  }}
                >
                  <DetailFormTitle
                    style={{
                      minWidth: 140,
                    }}
                  >
                    탈퇴일
                  </DetailFormTitle>
                  <DetailFormText>
                    {moment(userInfo?.createdAt).format("YYYY-MM-DD HH:mm")}
                  </DetailFormText>
                </DetailPageForm>
              </div>
            </div>
          </DetailPage>
        </DetailPageLayout>
      </MainLayout>

      {/* 삭제 모달 */}
      {deleteModalOpen && (
        <Modal
          type="negative"
          title="삭제하시겠습니까?"
          text={
            <>
              삭제된 데이터는 복구가 불가합니다.
              <br />
              그래도 삭제하시겠습니까?
            </>
          }
          setModalOpen={setDeleteModalOpen}
          onClick={deleteFunc}
        />
      )}
    </>
  );
};

export default UserWithdrawDetail;
